<template>
  <div class="app-container">
    <div class="from-panel" ref="panel">
      <div class="from-title">
        <!-- <el-button
          icon="el-icon-back"
          type="info"
          size="mini"
          circle
          plain
          style="margin-right: 15px"
          @click="$router.push('/')"
        ></el-button> -->
        <!-- <span>流程面板</span> -->
        <!-- <span style="color: #c75450; margin-left: 20px"
          >📢
          大家要体验的话，尽量使用已有的分组和流程进行编辑，不要随意新建，数据有点乱哈，谢谢了❤</span
        > -->
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="newProcess"
            >新建表单</el-button
          >
          <el-button icon="el-icon-refresh" @click="refresh" size="mini"
            >刷新</el-button
          >
        </div>
      </div>
      <!-- handle=".el-icon-rank" -->
      <!-- <draggable
        :list="groups"
        group="group"
        filter=".undrag"
        @start="groupsSort = true"
        :options="{
          animation: 300,
          sort: true,
          scroll: true,
          chosenClass: 'choose',
        }"
        @end="groupSort"
      > -->
      <div
        :class="{
          'form-group': true,
          undrag: group.GroupId === 0 || group.GroupId === undefined,
        }"
        v-for="(group, gidx) in groups"
        :key="gidx"
      >
        <!-- v-show="group.GroupId > 1 || group.tptList.length > 0" -->
        <div class="form-group-title">
          <img v-if="group.icon" :src="group.icon" alt="" class="icon" />
          <span class="sortName" style="margin-left: 18px">{{
            group.name
          }}</span>
          <span v-if="group.tptList">({{ group.tptList.length }})</span>
          <span v-else>(0)</span>
          <!-- <i class="el-icon-rank" title="长按拖动可对分组排序"></i> -->
          <!-- <div v-if="!(group.GroupId === 0 || group.GroupId === undefined)">
            <el-dropdown>
              <el-button type="text" icon="el-icon-setting">编辑分组</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  icon="el-icon-edit-outline"
                  @click.native="editGroup(group)"
                  >修改名称</el-dropdown-item
                >
                <el-dropdown-item
                  icon="el-icon-delete"
                  @click.native="delGroup(group)"
                  >删除分组</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
        </div>
        <!-- <draggable
            style="width: 100%; min-height: 25px"
            :list="group.tptList"
            group="from"
            @end="groupSort"
            v-show="!groupsSort"
            filter=".undrag"
            :options="{
              animation: 300,
              delay: 200,
              chosenClass: 'choose',
              scroll: true,
              sort: true,
            }"
          > -->
        <!-- title="长按0.5S后可拖拽表单进行排序" -->
        <div
          :class="{ 'form-group-item': true, undrag: item.isStop }"
          v-for="(item, index) in group.tptList"
          :key="index"
        >
          <div style="display: flex; align-items: center">
            <!-- <img v-if="group.icon" :src="group.icon" alt="" class="icon" /> -->
            <i
              v-if="item.icon"
              :class="item.icon.icon"
              :style="'background: ' + item.icon.background"
            ></i>
            <span>{{ item.name }}</span
            ><br />
          </div>
          <div class="desp">{{ item.remark }}</div>
          <div>
            <span>最后更新时间：{{ item.updateTime | Time }}</span>
          </div>
          <div>
            <el-button
              type="text"
              icon="el-icon-edit-outline"
              size="mini"
              @click="editFrom(item, group)"
              >编辑</el-button
            >
            <el-button
              type="text"
              :icon="item.status == 2 ? 'el-icon-check' : 'el-icon-close'"
              size="mini"
              @click="stopFrom(item)"
            >
              {{ item.status == 1 ? "禁用" : "启用" }}
            </el-button>

            <el-button
              type="text"
              icon="el-icon-delete"
              size="mini"
              @click="moveFrom(item)"
              v-if="item.status == 2"
              >删除
            </el-button>
            <!-- <el-popover
              placement="left"
              trigger="click"
              width="400"
              style="margin-left: 10px"
              @show="moveSelect === null"
              v-else
            >
              <el-radio-group v-model="moveSelect" size="mini">
                <el-radio
                  :label="g.GroupId"
                  border
                  v-for="g in groups"
                  :key="g.GroupId"
                  v-show="g.GroupId > 1"
                  :disabled="g.GroupId === group.GroupId"
                  style="margin: 10px"
                  >{{ g.Name }}</el-radio
                >
              </el-radio-group>
              <div style="text-align: right; margin: 0">
                <el-button type="primary" size="mini" @click="moveFrom(item)"
                  >提交</el-button
                >
              </div>
              <el-button
                slot="reference"
                type="text"
                icon="el-icon-s-promotion"
                size="mini"
                >移动</el-button
              >
            </el-popover> -->
          </div>
        </div>
        <!-- </draggable> -->
        <div
          style="text-align: center"
          v-if="group.tptList === undefined || group.tptList.length === 0"
        >
          <el-button
            style="padding-top: 16px"
            type="text"
            icon="el-icon-plus"
            @click="newProcess(group.id)"
            >创建新表单</el-button
          >
        </div>
      </div>
      <div class="no-data" v-show="groups.length == 0">
        暂无数据 😀
      </div>
      <!-- </draggable> -->

      <!-- 编辑 -->
      <popup-frame1 title="编辑" :dialogVisible.sync="EnrolVisible">
        <FormProcessDesign
          :code="code"
          :groupId="groupId"
          @close="closeChild"
        ></FormProcessDesign>
      </popup-frame1>
    </div>
  </div>
</template>

<script>
import {
  groupItemsSort,
  updateGroup,
  updateForm,
  deletForm,
} from "@/api/design";
import { GetGlobalTptList } from "@/api/Industry";
import PopupFrame1 from "@/components/PopupFrame1";
import FormProcessDesign from "./FormProcessDesign";
export default {
  name: "FormsPanel",
  components: { PopupFrame1, FormProcessDesign },
  data() {
    return {
      update: false,
      add: false,
      delet: false,
      moveSelect: "",
      visible: false,
      groupsSort: false,
      groups: [],
      EnrolVisible: false,
      code: "",
      groupId: "",
    };
  },
  provide() {
    return { closeChild: this.closeChild };
  },
  filters: {
    Time(val) {
      return val.replace("T", " ");
    },
  },
  mounted() {
    this.getGroups();
    // this.$store.commit("setSort", this.sort);
  },
  methods: {
    closeChild() {
      this.EnrolVisible = false;
      this.getGroups();
    },
    refresh() {
      this.getGroups();
    },
    getGroups() {
      GetGlobalTptList({
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      }).then((rsp) => {
        this.groups = rsp.data;
        if (this.groups) {
          this.groups.forEach((group) => {
            if (group.tptList) {
              group.tptList.forEach((item) => {
                item.icon = JSON.parse(item.logo);
                //   console.log(item.icon);
              });
            }
          });
        }
      });
      // .catch((err) => this.$message.error("获取分组异常"));
    },
    newProcess(groupId) {
      this.$store.commit("setTemplate", this.getTemplateData());
      this.$store.commit("setIsEdit", false);
      // this.$router.push("/admin/design?groupId=" + groupId);
      this.groupId = groupId;
      this.EnrolVisible = true;
      this.code = null;
    },
    groupSort() {
      this.groupsSort = false;
      groupItemsSort(this.groups)
        .then((rsp) => {
          this.$message.success(rsp.data);
          this.getGroups();
        })
        .catch((err) => {
          this.getGroups();
          this.$message.error(err.response.data);
        });
    },
    addGroup() {
      this.$prompt("请输入要添加的组名", "新的分组名", {
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        inputPattern: /^[\u4E00-\u9FA5A-Za-z0-9\\-]{1,30}$/,
        inputErrorMessage: "分组名不能为空且长度小于30",
        inputPlaceholder: "请输入分组名",
      }).then(({ value }) => {
        updateGroup({ name: value }, "post")
          .then((rsp) => {
            this.$message.success(rsp.data);
            this.getGroups();
          })
          .catch((err) => this.$message.error(err.response.data));
      });
    },
    delGroup(group) {
      this.$confirm(
        "删除分组并不会删除表单，表单将会被转移到 “其他” 分组，确定要删除分组 " +
          group.name +
          "?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        updateGroup({ GroupId: group.GroupId }, "delete")
          .then((rsp) => {
            this.$message.success(rsp.data);
            this.getGroups();
          })
          .catch((err) => this.$message.error(err.response.data));
      });
    },
    editGroup(group) {
      this.$prompt("请输入新的组名", "修改分组名", {
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        inputPattern: /^[\u4E00-\u9FA5A-Za-z0-9\\-]{1,30}$/,
        inputErrorMessage: "分组名不能为空且长度小于30",
        inputPlaceholder: "请输入分组名",
        inputValue: group.name,
      }).then(({ value }) => {
        updateGroup({ GroupId: group.GroupId, name: value }, "put")
          .then((rsp) => {
            this.$message.success(rsp.data);
            this.getGroups();
          })
          .catch((err) => this.$message.error(err.response.data));
      });
    },
    updateForm(item, type) {
      console.log(1111);
      updateForm({ tptId: item.tptId, status: type })
        .then((rsp) => {
          this.$message.success("操作成功");
          this.getGroups();
        })
        .catch((err) => this.$message.error(err.response.data));
    },
    getTemplateData(data, group) {
      return data;
    },
    editFrom(item, group) {
      console.log(item, "模板id");
      console.log(group, "group");
      //   this.$router.push("/admin/design?code=" + item.tptId);
      this.EnrolVisible = true;
      this.code = item.tptId;
    },
    stopFrom(item) {
      let tip = item.status == 1 ? "禁用" : "启用";
      this.$confirm("您确定要" + tip + "该模板吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (item.status == 1) {
          item.status = 2;
        } else {
          item.status = 1;
        }
        this.updateForm(item, item.status);
      });
    },
    moveFrom(item) {
      // if (item.isStop) {
      this.$confirm(
        "您确定要删除该模板吗，删除后无法恢复，是否继续？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        deletForm({ tptId: item.tptId })
          .then((rsp) => {
            this.$message.success("删除成功");
            this.getGroups();
          })
          .catch((err) => this.$message.error(err.response.data));
      });
      // } else {
      //   if (this.moveSelect === null || this.moveSelect === "") {
      //     this.$message.error("请选择分组");
      //     return;
      //   }
      //   updateForm({
      //     templateId: item.GroupId,
      //     type: "move",
      //     groupId: this.moveSelect,
      //   })
      //     .then((rsp) => {
      //       this.$message.success(rsp.data);
      //       this.getGroups();
      //       this.moveSelect = null;
      //     })
      //     .catch((err) => this.$message.error(err.response.data));
      // }
    },
  },
};
</script>

<style lang="less" scoped>
body {
  background: #ffffff !important;
}

.undrag {
  //   background: #ebecee !important;
}

.from-panel {
  //   padding: 50px 100px;
  min-width: 500px;
  background: #ffffff;

  /deep/ .from-title {
    height: 30px;
    div {
      float: right;

      .el-button {
        border-radius: 15px;
      }
    }
  }

  //height: 100vh;
}

.choose {
  background: #e9ebee;
}
.form-group {
  margin: 20px 0;
  padding: 5px 0px;
  border-radius: 10px;
  //border: 1px solid #d3d3d3;
  box-shadow: 1px 1px 10px 0 #d2d2d2;

  &:hover {
    box-shadow: 1px 1px 12px 0 #b3b3b3;
  }

  .form-group-title {
    // padding: 5px 20px;
    height: 51px;
    line-height: 51px;
    border-bottom: 1px solid #d3d3d3;
    display: flex;
    align-items: center;

    .el-icon-rank {
      display: none;
      cursor: move;
    }

    &:hover {
      .el-icon-rank {
        display: inline-block;
      }
    }

    div {
      display: inline-block;
      float: right;
    }

    span:first-child {
      margin-right: 5px;
      font-size: 15px;
      font-weight: bold;
    }

    span:nth-child(2) {
      color: #656565;
      font-size: small;
      margin-right: 10px;
    }

    /deep/ .el-button {
      color: #404040;
      margin-left: 20px;

      &:hover {
        color: #2b2b2b;
      }
    }
  }

  .form-group-item {
    color: #3e3e3e;
    font-size: small;
    // padding: 10px 0;
    margin: 0 20px 0 56px;
    height: 60px;
    position: relative;
    line-height: 60px;
    border-top: 1px solid #d3d3d3;

    div {
      display: inline-block;
    }

    i {
      border-radius: 10px;
      padding: 7px;
      font-size: 20px;
      color: #ffffff;
      margin-right: 10px;
      line-height: 20px;
    }

    div:nth-child(1) {
      float: left;
    }

    div:nth-child(2) {
      position: absolute;
      color: #7a7a7a;
      font-size: 12px;
      left: 200px;
      max-width: 300px;
      overflow: hidden;
    }

    div:nth-child(3) {
      position: absolute;
      right: 30%;
    }

    div:nth-child(4) {
      float: right;
    }
  }
}

@media screen and (max-width: 1000px) {
  .desp {
    display: none !important;
  }
}

@media screen and (max-width: 800px) {
  .from-panel {
    padding: 50px 10px;
  }
}

.sortName {
  margin-right: 5px !important;
  font-size: 15px !important;
  font-weight: bold;
}

.icon {
  display: block;
  width: 33px;
  height: 33px;
  vertical-align: middle;
  margin: 0px -6px 0 18px;
  border-radius: 10px;
}
</style>

<style scoped>
.form-group .form-group-item:nth-child(2) {
  border-top: none !important;
}

.no-data {
  text-align: center;
  padding: 50px 0;
  color: #656565;
  margin: 0 auto;
}
</style>
